import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { Tag } from "../../ui";

// Students may apply without meeting a programme's rules; staff see it on their lists
export function NotEligibleTag({ meets }) {
  return meets === false ? <Tag color="yellow">Eligibility not met</Tag> : null;
}

// The applicant's name on a staff list, flagged when their submitted profile missed the programme's rules
export function ApplicantName({ name, meets }) {
  return (
    <span className="flex flex-wrap items-center gap-2">
      <span className="font-medium text-slate-800">{name}</span>
      <NotEligibleTag meets={meets} />
    </span>
  );
}

/**
 * The rules of the programme the applicant's profile, as submitted, did not meet (`eligibility` as
 * the API gives it: eligible, unmetRules). Nothing when they met them or the programme has none.
 */
export default function EligibilityFlag({ eligibility }) {
  if (!eligibility || eligibility.eligible) return null;
  return (
    <div className="flex items-start gap-2 rounded-md bg-amber-50 p-3 text-sm text-amber-800">
      <ExclamationTriangleIcon className="h-5 w-5 shrink-0" />
      <div>
        <p className="font-semibold">Eligibility not met: the applicant's academic profile did not meet</p>
        <ul className="mt-1 list-disc pl-5">
          {eligibility.unmetRules.map((r) => (
            <li key={`${r.kind}-${r.value}`}>{r.label ?? r.value}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}
